import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol/*, ContainerEdit */} from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, /*LabelCabecera, LabelNota */} from '../../componentes/componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import { completar_String } from '../../funciones_globales/format';
//import styled from 'styled-components';
//import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
//import { cargarCatalogoEstados, cargarCatalogos_Otros }from '../../funciones_globales/catalogos';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
//import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
//import SelectArticulo from '../inventario/selectArticulo';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
//import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
//import moment from 'moment';
//import { formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';


class FormVen21 extends React.Component{   
    constructor(props) {
        super(props);
        this.state = {
            //Iniciales
            fechaProceso: null,  
          
            //Parametros
            // userId: null,

            //Cargo 
            userCargo: null,

            //Text
            observacion: '',

            //GRID PEDIDO
            data_pedidos: [],
            columnDefs: [   
                            {   header: "",
                                width: 30,
                                suppressRowClickSelection: true,
                                checkboxSelection: true,
                                suppressSorting: true,
                                suppressMenu: true,
                                suppressFilter: true,
                                pinned: true 
                            },
                            {   header: "No.",
                                field: "NroItem",
                                width: 40,
                                type: "string",
                                suppressFilter: true,
                            },
                            {   header: "Pedido",
                                field: "Pedido",
                                width: 70,
                                type: "string"
                            },
                            {   header: "Fecha Pedido",
                                field: "FechaPedido",
                                width: 120,
                                type: "string"
                            },
                            {   header: "Fecha Ing. Sist.",
                                field: "FechaIngSist",
                                width: 120,
                                type: "string"
                            },
                            {   header: "Cliente",
                                field: "Cliente",
                                width: 250,
                                type: "string"
                            },
                            {   header: "Clase",
                                field: "ClaseCliente",
                                width: 65,
                                type: "string"
                            },
                            {   header: "Vendedor",
                                field: "Vendedor",
                                width: 200,
                                type: "string"
                            },
                            // {   header: "Ciudad",
                            //     field: "Ciudad",
                            //     width: 100,
                            //     type: "string"
                            // },
                            {   header: "Total",
                                field: "Total",
                                width: 70,
                                type: "num_decimal"
                            },
                            {   header: "Items",
                                field: "Items",
                                width: 65,
                                type: "num_entero"
                            },
                            // {   header: "Estado",
                            //     field: "Estado",
                            //     width: 90,
                            //     type: "string"
                            // },
                            {   header: "Oficial",
                                field: "Oficial",
                                width: 190,
                                type: "string"
                            },
                            // {   header: "Observación",
                            //     field: "Observacion",
                            //     width: 275,
                            //     type: "string"
                            // },
                            // {   header: "Notas",
                            //     field: "Notas",
                            //     width: 275,
                            //     type: "string"
                            // }  reubicar 
                            // {   header: "",
                            //     field: "modal",
                            //     width: 60,
                            //     type: "link_modal" 
                            // }                     
                        ],            
        };

        this.gridOptions = {
            context: {
              componentParent: this
            },
            getRowStyle:(params)=>{
            },
            rowSelection: "multiple",     
            enableColResize: true,
            enableCellChangeFlash: true,
            enableSorting: true,
            enableFilter: true,
            onCellValueChanged: ((event)=>{}),
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onGridReady = this.onGridReady.bind(this);
        this.aprobacionMasivaPedidos = this.aprobacionMasivaPedidos.bind(this);
        this.rechazoMasivoPedidos = this.rechazoMasivoPedidos.bind(this);
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    //ARRAY FUNCTION
    deleteItemArray (arr, index) {
        let indice = parseInt(index, 10);
        let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
        arr_tmp.forEach((item, i)=>{
          item.NroItem = completar_String((i + 1).toString(), '0', 3);
        });
        return arr_tmp;
    }
    
    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    //Funcion que permite eliminar
    methodFromParent(id, datos_fila){
        
    }

    //funcion que recibe parametros fila e invoca un popup
    methodDeployFromParent(id, datos_fila){
        //this.toggleModalCentroC();
    }

    //Nombre para el link de modalpopup
    methodNameFromParent(datos_fila){
        return "Historial"
    }

    //GRID
    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
    }

     //REACT CYCLE
    componentDidMount(){
        
        let fechaProceso = getFechaProcesoPorModulo('06');
        Promise.all([this.props.generar_LogAuditoriaIngresoForm('0421'),
        ])
        .then(()=>{

            this.consultarPedidosMoviles('A', 999, this.props.cargo).then((result_pedidos)=>{
                this.setState({fechaProceso: fechaProceso, 
                    data_pedidos: result_pedidos, userCargo: this.props.cargo})
                
                console.log('DATA ACCESADA POR CASO CONTRALOR: ', result_pedidos)
            })

            this.cargarObjetos(`/usuarios?login=${this.props.usuario}`).then((usr)=>{
                this.setState({UserId: usr.UsuarioId})
            })
        })
    }

    consultarPedidosMoviles(estado, nroRegistros, cargo){
        return new Promise((resolve, reject) => {
            var url = '/pedidosmoviles?cargo='+ cargo +'&estado=' + estado + '&limit=' + nroRegistros;
            global_axios({
                method: 'GET', 
                url
            })
            .then((response)=> {      
                let data_pedidos = response.data;      
                console.log("Pedidos moviles: ", data_pedidos)

                data_pedidos.forEach((pedido, i)=> {     
                    pedido.NroItem= completar_String((i+1).toString(), '0', 3);
                    pedido.Cliente = pedido.Cliente + ' - ' + pedido.NombreCliente;
                    pedido.Vendedor = pedido.Vendedor + ' - ' + pedido.NombreVendedor;
                    pedido.FechaPedido = pedido.FechaPedido + ' ' + pedido.HoraPedido;
                    pedido.FechaIngSist = pedido.FechaIngSist + ' ' + pedido.HoraIngSist;        
                });
                resolve(data_pedidos); 
            })
            .catch((error)=> {
                reject(error.response.data.msg?error.response.data.msg:error.message);
            });
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0421');
    }

    //ACTIONS BUTTONS
    aprobacionMasivaPedidos(){
        let errors = '';
        let continuar = true;

        if(!this.state.observacion){
            continuar = false;
            errors=' - Ingrese una observación antes de continuar\n' 
        }

        if(continuar===true){
            let data = {};
            data.arrayAprobaciones = this.formateoArraysPedido(this.api.getSelectedRows());
            data.Cargo = this.state.userCargo;
            data.Observacion = this.state.observacion
            console.log('Envio: ', data)

            global_axios({
                method: 'POST', 
                url: `/cargoporflujo/${data.Cargo}/apvpedido`,
                data
            })
            .then((response)=>{
                alert(response.data.msg);
    
                
            })
            .catch((error)=> {
                alert(error.response.data.msg?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }
    }

    rechazoMasivoPedidos(){
        let errors = '';
        let continuar = true;

        if(!this.state.observacion){
            continuar = false;
            errors=' - Ingrese una observación antes de continuar\n' 
        }

        if(continuar===true){
            let data = {};
            data.arrayAprobaciones = this.formateoArraysPedido(this.api.getSelectedRows());
            data.Cargo = this.state.userCargo;
            data.Observacion = this.state.observacion
            data.UsuarioId = this.state.userId;
            console.log('Envio: ', data)

            global_axios({
                method: 'POST', 
                url: `/cargoporflujo/${data.Cargo}/rchzpedido`,
                data
            })
            .then((response)=>{
                alert(response.data.msg);
            })
            .catch((error)=> {
                alert(error.response.data.msg?error.response.data.msg:error.message);
            });
        }else{
            alert(errors)
        }
    }

    historialAprobaciones(){

    }

    //OPERACIONES
    formateoArraysPedido(array){
        let newArray = [];

        array.forEach((DATA)=>{
            let item = {};

            item.Pedido = DATA.Pedido
            item.Fecha =  DATA.FechaPedido.substr(0,10);
            item.Total = DATA.Total
            item.RedireccionAprobacion = DATA.RedireccionAprobacion
            item.TerminoPago = DATA.TerminoPago
            item.InstanciaFlujo = DATA.InstanciaFlujo
            item.Estado = DATA.Estado.substr(0,1);
            item.DiasCredito = DATA.DiasCredito;
            item.Cupo = DATA.Cupo;

            newArray.push(item);
        })

        return newArray
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    render(){
        return(
            <div>
                <ContenedorForm porc_ancho={94}>
                    <HeaderForm>
                        <TituloForm>Aprobación de Pedidos Móviles (G)</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <Row>
                            <ContainerCol className='col-md-2'>
                                <LabelForm>Obs. Oficial:</LabelForm>
                                <InputText autoComplete='off' name='observacion' value={this.state.observacion} onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>
                            </ContainerCol>
                            <ContainerCol className='col-md-2'>
                                <LabelForm>Obs. Jefe Credito:</LabelForm>
                                <InputText autoComplete='off' name='observacion' value={this.state.observacion} onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>
                            </ContainerCol>
                            <ContainerCol className='col-md-2'>
                                <LabelForm>Obs. Comercial:</LabelForm>
                                <InputText autoComplete='off' name='observacion' value={this.state.observacion} onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-md-12'>                    
                                <AgGridRender altura='440px' data={this.state.data_pedidos} columnas={this.state.columnDefs}
                                gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-md-8'>
                                <Row>
                                    <ContainerCol className='col-md-2'>
                                        <LabelForm>Observación:</LabelForm>
                                    </ContainerCol> 
                                    <ContainerCol className='col-md-5'>
                                        <InputText autoComplete='off' name='observacion' value={this.state.observacion} onChange={this.handleInputChange} maxLength='70' mayusculas='true'/>
                                    </ContainerCol> 
                                    <ContainerCol className='col-md-5'>
                                        <button type='button'className='btn btn-default btn-sm' onClick={this.historialAprobaciones}><i className="fa fa-history"/></button>                                      
                                    </ContainerCol>
                                </Row>
                            </ContainerCol>     
                            <ContainerCol className='col-md-4'>
                                <div className='btn-group pull-right'>
                                    <button type='button' className='btn btn-primary btn-sm' onClick={this.aprobacionMasivaPedidos}><i className="fa fa fa-check-square fa-lg"/> Aprobar</button>    
                                    <button type='button' className='btn btn-danger btn-sm' onClick={this.rechazoMasivoPedidos}><i className="fa fa fa-window-close fa-lg"/> Rechazar</button>    
                                </div>
                            </ContainerCol>     
                        </Row>
                    </CuerpoForm>
                </ContenedorForm>
            </div>
        )
    }        
}
    
const mapStateToProps = state =>{
    return {  fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
                permiso: state.sesion.valoresSesionForm.Permiso,
                idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
                isVisibleLoading: state.ui.isVisibleLoading, 
                cargo: state.sesion.valoresSesionForm.Cargo,
                usuario: state.sesion.valoresSesionForm.Usuario,
                departamento: state.sesion.valoresSesionForm.Departamento 
    };
};
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, 
                            generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading
                            }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormVen21);